// TinyMCE so the global var exists
import "tinymce/tinymce";
// DOM model
import "tinymce/models/dom/model";
// Theme
import "tinymce/themes/silver";
// Toolbar icons
import "tinymce/icons/default";
// Editor styles
import "tinymce/skins/ui/oxide/skin";
// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/autosave";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/directionality";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/help";
import "tinymce/plugins/help/js/i18n/keynav/en";
import "tinymce/plugins/image";
import "tinymce/plugins/importcss";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/preview";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/save";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/wordcount";
// importing plugin resources
import "tinymce/plugins/emoticons/js/emojis";
// Content styles, including inline UI like fake cursors
import "tinymce/skins/content/default/content";
import "tinymce/skins/ui/oxide/content";

import { Editor } from "@tinymce/tinymce-react";
import { InitOptions } from "@tinymce/tinymce-react/lib/cjs/main/ts/components/Editor";
import { EventHandler } from "@tinymce/tinymce-react/lib/cjs/main/ts/Events";
import { Ref } from "react";

export function TinyMCE({
  className,
  value,
  ref,
  onChange,
  onFilePickerCallback,
  inline = false,
  tabIndex = 0,
}: Readonly<{
  className?: string;
  value?: string;
  ref?: Ref<Editor>;
  onChange?: EventHandler<unknown>;
  onFilePickerCallback?: (file: File) => Promise<string>;
  inline?: boolean;
  tabIndex?: number;
}>) {
  const initOptions: InitOptions = {
    plugins:
      "code preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help",
    toolbar:
      "SaveButton | formatselect | bold italic strikethrough forecolor backcolor permanentpen" +
      " formatpainter | link image media | alignleft aligncenter alignright alignjustify |" +
      " numlist bullist outdent indent | removeformat | addcomment",
    image_advtab: true,
    content_style: `
      .mce-content-body ul {
        list-style-type: disc;
        margin-left: 1rem;
      }

      .mce-content-body ol {
        list-style-type: decimal;
        margin-left: 1rem;
      }
    `,
    //document_base_url: "http://brf.test.test:3100",
    file_picker_callback: (
      callback: (value: string, meta?: Record<string, unknown>) => void,
    ) => {
      // Create input
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "*");

      input.onchange = async (): Promise<unknown> => {
        if (!input.files?.[0] || !onFilePickerCallback) {
          return;
        }

        const image = input.files[0];

        const form = new FormData();
        form.append("file", image);

        const url = await onFilePickerCallback(image);

        callback(url, {
          title: input.files[0].name,
        });
      };
      input.click();
    },
  };

  return (
    <div className={className}>
      <Editor
        ref={ref}
        init={initOptions}
        initialValue={value}
        inline={inline}
        tabIndex={tabIndex}
        onChange={onChange}
      />
    </div>
  );
}
